/**
 * Batch authenticity check.
 *
 * GRITVUE_BATCH_AUTH_CODE · the code printed on the authenticity card for the
 * current production batch. The same code is shared by every unit in a batch,
 * so a match confirms an authorized GritVue production batch, NOT one
 * individual unit. Leave empty until the real code is ready: the page then
 * shows a "being set up" state instead of a fake result.
 *
 * Note: a code checked in the browser can be read by anyone who inspects the
 * page. It is fine for a batch check; unique per-unit verification needs a
 * server (see AUTHENTICITY_VERIFICATION_URL).
 */
export const GRITVUE_BATCH_AUTH_CODE = ''

/**
 * AUTHENTICITY_VERIFICATION_URL · future endpoint or Shopify app for unique
 * per-unit codes. Not called anywhere until it exists.
 */
export const AUTHENTICITY_VERIFICATION_URL = ''

export function normalizeCode(value: string): string {
  return value.trim().toUpperCase().replace(/[\s-]/g, '')
}
